import { useTranslation } from 'react-i18next'

import { AppDialog } from '@/components/AppDialog'
import { UniteFeatureIllustration } from '@/components/icons/UniteFeatureIllustration'
import { PKG_UNITE_FEE_PER_PKG } from '@/helpers/pkgUtils'

interface AddToExistingUniteFeatureDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
}

export function AddToExistingUniteFeatureDialog({ open, onOpenChange }: AddToExistingUniteFeatureDialogProps) {
  const { t } = useTranslation()

  return (
    <AppDialog
      isOpen={open}
      onOpenChange={onOpenChange}
      title={t('unite.featureDialogTitle')}
      titleClassName='sr-only'
      className='sm:max-w-[600px]'
      alwaysDialog
      dialogContentClassName='px-6 py-8'
    >
      <div className='flex w-full flex-col items-center gap-6'>
        <div className='flex w-full flex-col items-center justify-center gap-4'>
          <UniteFeatureIllustration />
          <h2 className='text-text-primary text-center text-lg leading-7 font-medium'>{t('unite.featureDialogTitle')}</h2>
        </div>
        <div className='flex w-full flex-col items-center gap-6'>
          <p className='text-text-secondary text-center text-base leading-6 whitespace-pre-line'>{t('unite.featureDialogDesc')}</p>
          <div className='bg-button-primary-selected-segment flex h-7 items-center justify-center rounded-full px-2 py-1.5'>
            <p className='text-text-secondary text-center text-sm leading-5'>
              {t('unite.featureDialogFeeNote', { fee: PKG_UNITE_FEE_PER_PKG })}
            </p>
          </div>
        </div>
      </div>
    </AppDialog>
  )
}
